import { TINT } from "../lib/moduleColors";

// Chip d'icône « style B » (retravaillé le 2026-09-28, approuvé par
// l'utilisateur) : icône TEINTÉE dans un petit encart teinté, plutôt que le
// badge rond plein blanc de ModuleIcon — l'icône reste posée dans son label
// au lieu de flotter seule. Utilisé par StatWidget et RandomMissingCard,
// les 4 tuiles « chiffre » de l'accueil.
export const TintChip = ({ icon: Icon, color = "bg-zinc-500" }) => {
  const tint = TINT[color] || "113 113 122";
  return (
    <span
      className="tchip"
      style={{
        background: `rgb(${tint} / .16)`,
        boxShadow: `inset 0 0 0 1px rgb(${tint} / .3)`,
      }}
    >
      <Icon style={{ width: 14, height: 14, stroke: `rgb(${tint})` }} strokeWidth={2.3} strokeLinecap="round" fill="none" />
    </span>
  );
};
